import { Link } from "react-router-dom";
import { resolveAssetUrl, isLikelyImageSource, brandPath, categoryPath } from "../../config";
import { ProductCard } from "./ProductCard";
import { SectionPoster } from "./SectionPoster";

function normalizeListingLink(link) {
  if (!link || typeof link !== "string") return link;
  try {
    const qIndex = link.indexOf("?");
    if (qIndex < 0) return link;
    const params = new URLSearchParams(link.slice(qIndex + 1));
    const brandParam = params.get("brand");
    if (brandParam) return brandPath(brandParam);
    const categoryParam = params.get("category");
    if (categoryParam) return categoryPath(categoryParam);
  } catch {
    /* keep original */
  }
  return link;
}

export function PromoBannerSection({ section }) {
  const products = section.products || [];
  const brand = section.brand;

  const rawBannerUrl = section.bannerImageUrl?.trim();
  const bannerImageUrl =
    rawBannerUrl && isLikelyImageSource(rawBannerUrl) ? rawBannerUrl : "";
  const bannerUploadUrl = resolveAssetUrl(section.bannerImage);
  const hasBanner = !!(bannerImageUrl || bannerUploadUrl);

  const fallbackBrandLink = brand?.slug ? brandPath(brand.slug) : null;

  const brandLink =
    normalizeListingLink(section.bannerCtaLink) ||
    normalizeListingLink(section.viewAllLink) ||
    fallbackBrandLink;

  const viewAllLink =
    normalizeListingLink(section.viewAllLink) ||
    fallbackBrandLink;

  const viewAllLabel =
    section.viewAllLabel ||
    (brand?.name ? `${brand.name} Phones` : "View All");

  if (!hasBanner && !products.length && !section.title) return null;

  return (
    <section className="container mx-auto px-4 lg:px-8 py-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
        <h2 className="text-2xl sm:text-3xl font-display font-bold tracking-tight text-foreground">
          {section.title}
        </h2>
        {viewAllLink && (
          <Link
            to={viewAllLink}
            className="text-sm font-semibold text-primary hover:underline shrink-0"
          >
            {viewAllLabel}
          </Link>
        )}
      </div>

      {hasBanner && (
        <SectionPoster
          image={section.bannerImage}
          imageUrl={bannerImageUrl || undefined}
          link={brandLink}
          alt={section.title || brand?.name || "Promotional banner"}
          promo
        />
      )}

      {products.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 lg:gap-5 mt-6">
          {products.map((p) => (
            <ProductCard key={p._id || p.id} p={p} variant="legacy" />
          ))}
        </div>
      )}
    </section>
  );
}
